<template lang="html">
  <section class="loading"></section>
</template>

<script lang="js">
  
  import {mapActions} from 'vuex';

  import router from '@/router';

  export default  {
    name: 'logout',
    mounted(){
      this.requestLogout().then(r => {
        location.href = "/candidatos/login"
      })
    },
    methods:{
      ...mapActions(['requestLogout'])
    }
  }
</script>


<style scoped>
  .loading{
    min-height: 70vh;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/logout.vue